export const contact = {
  email: "ahmadzak2070@gmail.com",
  whatsapp: "+970568264676",
  whatsappDisplay: "+970 56 826 4676",
  whatsappUrl: "https://wa.me/970568264676",
  agencyName: "Salama Solutions",
  brandMark: "SS",
  tagline:
    "Smart digital systems, websites, automation, booking & ordering systems, and AI tools for local businesses.",
};
